import React, { useState, useEffect } from 'react';
import { Checkbox, Flex, Form, Modal, Typography } from 'antd';
import { AcceptTermsAndConditionsProps } from './accept-terms-types';
import CustomButton from '../custom-button/custom-button';
import { ExportOutlined } from '@ant-design/icons';
import { StyledLink } from './style-component';
import { Observer } from '@/utils/observer/observer';

const formSubmitObserver = new Observer<void>();

export { formSubmitObserver };

const { Text, Title } = Typography;

const AcceptTermsAndConditionsModal: React.FC<AcceptTermsAndConditionsProps> = () => {
  const [open, setOpen] = useState<boolean>();
  const [form] = Form.useForm();
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    if (localStorage.getItem('acceptedTermsAndConditions') !== 'true') {
      setOpen(true);
    }
  }, []);

  const handleSubmit = () => {
    localStorage.setItem('acceptedTermsAndConditions', 'true');
    setOpen(false);
    formSubmitObserver.notify();
  };

  return (
    <Modal
      open={open}
      closable={false}
      data-testid="onboarding-modal"
      styles={{
        body: { padding: 0 },
        footer: { padding: 0, margin: 0 },
        content: { borderRadius: "32px", overflow: "hidden" }
      }}
      footer={null}
    >
      <Flex gap="large" vertical>
        <div>
          <Title level={4}>¡Estás a punto de comenzar!</Title>
          <Text>Antes de comenzar a explorar, por favor acepta los términos de <b>Persea</b> by <b>Avocado Blockchain Services</b>.</Text>
        </div>
        <Form
          form={form}
          autoComplete='off'
          onFinish={handleSubmit}
        >
          <Form.Item name='accepted' valuePropName="checked">
            <Checkbox onChange={(e) => setIsChecked(e.target.checked)}>
              He leído y acepto los <StyledLink to='/terms-and-conditions'><b>Términos y Condiciones</b> <ExportOutlined /> </StyledLink> y la <StyledLink to='/privacy-policy'><b>Política de Privacidad y Protección de Datos Personales</b> <ExportOutlined /></StyledLink>
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <CustomButton type="primary" htmlType="submit" disabled={!isChecked} style={{ width: "fit-content", marginLeft: "auto" }}>
              Aceptar y continuar
            </CustomButton>
          </Form.Item>
        </Form>
      </Flex>
    </Modal>
  );
};

export default AcceptTermsAndConditionsModal;